import React from 'react';
import DetalizationItem from '../detalizationItem';
import { ReactComponent as ArrowRight } from '../../../../../@casino/img/right-arrow.svg';
import { ReactComponent as ArrowDown } from '../../../../../@casino/img/down-arrow.svg';
import { getDate } from '../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    w100: {
        width: '100%'
    },
    detalization: {
        paddingLeft: 8,
        paddingBottom: '6px',
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '100%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    detalizationGamer: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    },
    arrow: {
        fill: '#fff',
        width: 10,
        height: 10
    },
    wrapBlock: {
        display: 'flex',
        flexDirection: 'column'
    }
}))

const BlockDetalization = ({ profile }) => {
    const classes = useStyles();
    const [detalization, setDetalization] = React.useState(true);
    const detalArray = [
        { label: 'Статус', description: Number(profile.online) + 900000 > new Date().getTime() ? 'Online' : 'Offline' },
        { label: 'ID игрока', description: profile.id },
        { label: 'Client ID', description: profile.client_id },
        { label: 'Логин', description: profile.login },
        { label: 'Имя custom', description: profile.description },
        { label: 'Имя', description: profile?.name},
        { label: 'Фамилия', description: profile?.surname},
        { label: 'Телефон', description: Number(profile.phone) || '-' },
        { label: 'Email', description: profile.email || '-' },
        // { label: 'Бонус при регистрации', description: !profile.active_bonuses_registration ? "Бонус не выбран" : profile.active_bonuses_registration === 'alldeposit' ? '100% на депозит' : profile.active_bonuses_registration === 'fs30' ? '50% + 75FS' : '150FS' },
        { label: 'Wager', description: profile.wager?.toFixed(2) },
        { label: 'Wager PAY', description: profile?.wager_pay },
        { label: 'Wager Freespin', description: profile?.wager_freespin },
        { label: 'Сумма депозитов', description: profile.sum_deposit.toFixed(2) },
        { label: 'Количество депозитов', description: profile.count_deposit },
        { label: 'Сумма выводов', description: profile.sum_withdrawals.toFixed(2) },
        { label: 'Количество выводов', description: profile.withdrawals },
        { label: 'Прибыль', description: (+profile.sum_deposit - +profile.sum_withdrawals).toFixed(2) },
        { label: 'Спортивный баланс', description: profile.balance_sport.toFixed(2) },
        { label: 'Баланс', description: profile.balance.toFixed(2) },
        { label: 'Воздушный баланс', description: profile.air_balance.toFixed(2) },
        { label: 'Валюта', description: profile.currency },
        { label: 'Полученные бонусы', description: +profile.sum_bonuses },
        { label: 'Количество бонусов', description: profile.count_bonuses },
        { label: 'Сумма ставок', description: profile.sum_bet.toFixed(2) },
        { label: 'Сумма выигрышей', description: profile.sum_win.toFixed(2) },
        { label: 'Разница', description: (+profile.sum_bet - +profile.sum_win).toFixed(2) },
        { label: 'Сумма выигрышей джекпотов', description: profile.sum_jackpot.toFixed(2) },
        { label: 'Количество выигранных джекпотов', description: profile.count_jackpot },
        { label: 'Дата регистрации', description: getDate(+profile.registration) },
        { label: 'Cсылка регистрации', description: profile.mirror },
        { label: 'Реферрал', description: profile.referral },
        { label: 'Последнее действие', description: profile.type_last_replenishment },
    ]

    return (
        <div className={classes.w100}>
            <div
                className={classes.detalization}
                onClick={() => {
                    setDetalization(!detalization)
                }}
            >
                <span
                    className={classes.detalizationGamer}
                >
                    Детализация по игроку
                </span>
                {
                    !detalization &&
                    <ArrowRight className={classes.arrow} />
                }
                {
                    detalization &&
                    <ArrowDown className={classes.arrow} />
                }
            </div>
            {
                detalization &&
                <div className={classes.wrapBlock}>
                    {
                        profile.dublicate && (
                            <span style={{
                                padding: '15px 20px',
                                background: '#FF403D',
                                color: '#fff',
                                fontFamily: 'PT-sans, sans-serif',
                                fontSize: 14,
                                textAlign: 'center',
                                borderRadius: 4,
                                marginBottom: 12,
                                fontWeight: 700
                            }}>ДУБЛИКАТ</span>
                        )
                    }
                    {
                        profile.block && (
                            <span style={{
                                padding: '15px 20px',
                                background: '#FF403D',
                                color: '#fff',
                                fontFamily: 'PT-sans, sans-serif',
                                fontSize: 14,
                                textAlign: 'center',
                                borderRadius: 4,
                                marginBottom: 12,
                                fontWeight: 700
                            }}>ЗАБЛОКИРОВАН</span>
                        )
                    }
                    {
                        detalArray.map((item, key) => <DetalizationItem label={item.label} description={item.description} id={profile.id} />)
                    }

                </div>
            }
        </div>
    )
}

export default BlockDetalization;